namespace TabAurous.Finance {
    export interface ServiceOutwardForm {
        TransId: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        LedgerId: Serenity.ServiceLookupEditor;
        LedgerName: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        State: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        TaxLedgerId: Serenity.IntegerEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchangeRate: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        Details: ServiceOutwardDetailsEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        TaxDetails: ServiceOutwardTaxEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class ServiceOutwardForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.ServiceOutward';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ServiceOutwardForm.init)  {
                ServiceOutwardForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DecimalEditor;
                var w7 = ServiceOutwardDetailsEditor;
                var w8 = ServiceOutwardTaxEditor;

                Q.initFormType(ServiceOutwardForm, [
                    'TransId', w0,
                    'TransDate', w1,
                    'VoucherNo', w0,
                    'LedgerId', w2,
                    'LedgerName', w0,
                    'Address1', w3,
                    'State', w0,
                    'Country', w0,
                    'TaxLedgerId', w4,
                    'CurrencyId', w5,
                    'ExchangeRate', w6,
                    'UserId', w5,
                    'RefNo', w0,
                    'RefDate', w1,
                    'Details', w7,
                    'VoucherTypeId', w4,
                    'TaxDetails', w8,
                    'NetAmount', w6,
                    'TaxAmount', w6,
                    'GrossAmount', w6,
                    'Narration', w0,
                    'CompanyId', w4,
                    'FinancialYearId', w4
                ]);
            }
        }
    }
}
